import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-list',
  templateUrl: './empty-list.component.html',
  styleUrls: ['./empty-list.component.scss'],
  standalone: false
})
export class EmptyListComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
